import {
  getBestOffersList,
  getOffersList,
  getRecentOffersList,
  getTopOffersList,
} from 'services/offer';

import LINKS from './links';

const LIMIT = 24;

const HOME_OFFERS_LIST_TABS = [
  {
    fetcher: ({ after, before, filters }, opts) =>
      getOffersList(
        {
          after,
          before,
          filters,
          limit: LIMIT,
        },
        opts
      ),
    href: LINKS.HOME,
    iconName: 'bolt',
    id: 'highlights',
    title: 'Destaques',
  },
  {
    fetcher: ({ after, before, filters }, opts) =>
      getRecentOffersList(
        {
          after,
          before,
          filters,
          limit: LIMIT,
        },
        opts
      ),
    href: LINKS.RECENT_OFFERS,
    iconName: 'clock-filled',
    id: 'recents',
    title: 'Recentes',
  },
  {
    fetcher: ({ after, before, filters }, opts) =>
      getBestOffersList(
        {
          after,
          before,
          filters,
          limit: LIMIT,
        },
        opts
      ),
    href: LINKS.TREND_OFFERS,
    iconName: 'thermostat',
    id: 'trend',
    title: 'Em alta',
  },
  {
    fetcher: ({ after, before, filters }, opts) =>
      getTopOffersList(
        {
          after,
          before,
          filters,
          limit: LIMIT,
        },
        opts
      ),
    href: LINKS.LOW_PRICE_OFFERS,
    iconName: 'trending-down',
    id: 'low_price',
    title: 'Menor preço',
  },
];

export default HOME_OFFERS_LIST_TABS;
